// filepath: src/apps/policymaker/pages/PIR/page/PIRCollectionRequestsHeader.jsx
import React from 'react';
import {Stack, Typography} from '@mui/material';
import PIRCreateIcrDialog from './PIRCreateIcrDialog';

/**
 * Header part of the Collection Requests UI. Renders a title and optional actions.
 */
export default function PIRCollectionRequestsHeader({title = 'Collection requests', actions = null, pirId = null}) {
    return (
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
            <Typography variant={'h6'}>{title}</Typography>
            <Stack direction={'row'} spacing={1}>
                {actions}
                <PIRCreateIcrDialog pirId={pirId}/>
            </Stack>
        </Stack>
    );
}
